// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_botaoPopupSalvar__DGaD9 {
  width: 180px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.styles_botaoPopupSalvar__DGaD9:hover {
  transform: scale(0.95) !important;
}

.styles_botaoPopupCancelar__E-uWN {
  width: 180px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
}

.styles_botaoPopupCancelar__E-uWN:hover {
  transform: scale(0.95) !important;
}

.styles_formContent__WX-p7 {
  flex-grow: 1;
}

.styles_formContainer__WdTw1 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.styles_formDiv__GxXdx {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
.styles_campoNumero__YlFm8 {
  width: 120px !important;
}`, "",{"version":3,"sources":["webpack://./src/forms/IncidenciasVerbaManualForm/styles.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".botaoPopupSalvar {\n  width: 180px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n}\n\n.botaoPopupSalvar:hover {\n  transform: scale(0.95) !important;\n}\n\n.botaoPopupCancelar {\n  width: 180px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n}\n\n.botaoPopupCancelar:hover {\n  transform: scale(0.95) !important;\n}\n\n.formContent {\n  flex-grow: 1;\n}\n\n.formContainer {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.formDiv {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n}\n.campoNumero {\n  width: 120px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"botaoPopupSalvar": `styles_botaoPopupSalvar__DGaD9`,
	"botaoPopupCancelar": `styles_botaoPopupCancelar__E-uWN`,
	"formContent": `styles_formContent__WX-p7`,
	"formContainer": `styles_formContainer__WdTw1`,
	"formDiv": `styles_formDiv__GxXdx`,
	"campoNumero": `styles_campoNumero__YlFm8`
};
export default ___CSS_LOADER_EXPORT___;
